import { makeStyles } from '@material-ui/core/styles';

const useCalendarPickerStyles = makeStyles({
  root:{
    '&:focus-within label span, &:hover label span':{
      color:'var(--teal-blue)'
    }
  },
  calendar_icon: {
    color: 'var(--deep-ocean-blue)'
  },
  error__container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%'
  },
  endAdornmentWrapper: {
    '& svg': {
      color: 'var(--teal-blue)'
    }
  },
  helpTooltipAdornment: {
    zIndex: 1,
    cursor: 'auto',
    marginTop: '6px'
  },
  popover : {
    marginRight: "-85px !important"
  },
  requiredAsterisk: {
    marginLeft: '3px',
    color: 'var(--light-venetian-red)'
  },
  error:{
    color: 'var(--light-venetian-red)'
  }
});

export default useCalendarPickerStyles;